import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client';
import AuthLink from './AuthLink';
import RefreshTokenLink from './RefreshTokenLink';
import TokenService from './TokenService';
import errorLink from './errorLink';
import SessionService from './SessionService';

const tokenService = TokenService.getInstance();
const sessionService = SessionService.getInstance();
export const gqlUri = process.env.REACT_APP_GQL_SERVER_URL as string;
export const client = new ApolloClient({
    // Links chain - check if token expired and refresh -> add auth token to headers -> send request
    link: ApolloLink.from([
        // Must be first so retries re-run AuthLink with the new token
        errorLink(tokenService, sessionService),
        new RefreshTokenLink(tokenService, sessionService),
        new AuthLink(tokenService, sessionService),
        new HttpLink({
            uri: gqlUri,
        }),
    ]),
    cache: new InMemoryCache({
        typePolicies: {
            RentalAgreement: {
                fields: {
                    id: {
                        merge(existing, incoming, { mergeObjects }) {
                            // Correct, thanks to invoking nested merge functions.
                            return mergeObjects(existing, incoming);
                        },
                    },
                },
            },
        },
    }),
    connectToDevTools: true,
});
